import { defineStore } from "pinia";
import { stimuliObject, projectObject } from "@/interfaces";
const emptyProject = {
  id: null,
  stimuli: [],
  services: [],
  clientName: "",
  ownerEmail: "",
  projectName: "",
  description: "",
  maxAllowedRespondents: 1,
  segmentations: [
    {
      id: "0",
      label: "All Age-Groups",
      question: "Your age group?",
      options: ["< 18", "18 - 24", "25 - 34", "35 - 44", "> 45"],
    },
    {
      id: "1",
      label: "All Genders",
      question: "Your gender?",
      options: ["female", "male", "neutral"],
    },
  ],
};
export const useProjectStimuliStore = defineStore("projectStimuliStore", {
  state: () => ({
    project: JSON.parse(JSON.stringify(emptyProject)) as projectObject,
  }),
  getters: {
    getStimul: (state) => (stimulId: string) =>
      state.project?.stimuli?.find((a) => a.id === stimulId),
  },
  actions: {
    updateProject(form: projectObject) {
      this.project = form;
    },
    resetProject() {
      this.project = JSON.parse(JSON.stringify(emptyProject));
    },
    addStimuli(stimuli: stimuliObject) {
      this.project?.stimuli?.push(stimuli);
    },
    updateStimuli(stimuli: stimuliObject): void {
      if (this.project && this.project.stimuli) {
        const index = this.project?.stimuli?.findIndex(
          (item) => item.id === stimuli.id
        );
        if (index !== -1) {
          this.project.stimuli[index] = stimuli;
        } else {
          this.project.stimuli.push(stimuli);
        }
      }
    },
    deleteStimuli(stimuli: stimuliObject) {
      if (this.project?.stimuli) {
        this.project.stimuli = this.project?.stimuli.filter(
          (obj: stimuliObject) => obj.id !== stimuli.id
        );
      }
    },
  },
});
